/**
 * Why an email sign-up was refused, when the API says (mpgadmin G104).
 *
 * The CMS answers `{ error, code }` (CMS G29). Before G29 it put the API's
 * own body inside its `details`, after "Registration failed: ". A coded refusal from the API
 * carries its code in `additionalInfo.code` and the sentence to show in
 * `details`.
 */

/** The verification email couldn't go, so nothing was kept: fix the address and try again. */
export const VERIFICATION_EMAIL_FAILED = 'verification-email-failed';

export interface RegisterRefusal {
  code?: string;
  message?: string;
}

export const readRegisterRefusal = (cmsBody: unknown): RegisterRefusal => {
  // From CMS G29 the CMS sends the code and the sentence itself: `{ error, code }`.
  const body = cmsBody as { code?: unknown; error?: unknown } | null;
  if (body && typeof body === 'object' && typeof body.code === 'string') {
    return { code: body.code, message: typeof body.error === 'string' ? body.error : undefined };
  }
  const details = (cmsBody as { details?: unknown } | null)?.details;
  if (typeof details !== 'string') return {};
  const start = details.indexOf('{');
  if (start < 0) return {};
  try {
    const api = JSON.parse(details.slice(start));
    return {
      code: typeof api?.additionalInfo?.code === 'string' ? api.additionalInfo.code : undefined,
      message: typeof api?.details === 'string' ? api.details : undefined,
    };
  } catch {
    return {};
  }
};
